'use client';

import React from 'react';

import { ToasterProvider } from '@bytel/trilogy-react-ts';
import { TrilogyProviderStyled } from '@bytel/trilogy-react-ts/lib/context/providerStyled';

export function TrilogyProvider({ children }: Readonly<{ children: React.ReactNode }>) {
    return (
        <TrilogyProviderStyled>
            <ToasterProvider>{children}</ToasterProvider>
        </TrilogyProviderStyled>
    );
}
